(function() {
  'use strict';

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    initMobileMenu();
    initMobileSubmenu();
    initScrollBehavior();
    initCartUpdate();
    initDropdownEnhancements();
    initSearchEnhancements();
    initAccessibility();
  }

  function initMobileMenu() {
    const toggleBtn = document.querySelector('.SPM__navbar__mobile-toggle');
    const closeBtn = document.querySelector('.SPM__navbar__mobile-close');
    const overlay = document.querySelector('.SPM__navbar__mobile-overlay');
    const mobileMenu = document.querySelector('.SPM__navbar__mobile-menu');
    const body = document.body;

    if (!toggleBtn || !mobileMenu || !overlay) return;

    toggleBtn.addEventListener('click', function() {
      mobileMenu.classList.add('active');
      overlay.classList.add('active');
      body.style.overflow = 'hidden';
    });

    function closeMenu() {
      mobileMenu.classList.remove('active');
      overlay.classList.remove('active');
      body.style.overflow = '';
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', closeMenu);
    }

    overlay.addEventListener('click', closeMenu);

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && mobileMenu.classList.contains('active')) {
        closeMenu();
      }
    });

    let resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        if (window.innerWidth > 768 && mobileMenu.classList.contains('active')) {
          closeMenu();
        }
      }, 250);
    });
  }

  function initMobileSubmenu() {
    const expandButtons = document.querySelectorAll('.SPM__navbar__mobile-expand');

    expandButtons.forEach(function(button) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        const parentItem = button.closest('.SPM__navbar__mobile-item');
        const submenu = parentItem.querySelector('.SPM__navbar__mobile-submenu');

        if (!submenu) return;

        const isActive = button.classList.contains('active');
        
        document.querySelectorAll('.SPM__navbar__mobile-expand.active').forEach(function(btn) {
          if (btn !== button) {
            btn.classList.remove('active');
            const otherSubmenu = btn.closest('.SPM__navbar__mobile-item').querySelector('.SPM__navbar__mobile-submenu');
            if (otherSubmenu) {
              otherSubmenu.classList.remove('active');
            }
          }
        });

        if (isActive) {
          button.classList.remove('active');
          submenu.classList.remove('active');
        } else {
          button.classList.add('active');
          submenu.classList.add('active');
        }
      });
    });
  }

  function initScrollBehavior() {
    const header = document.querySelector('.SPM__navbar__header');
    if (!header) return;

    window.addEventListener('scroll', function() {
      const currentScroll = window.pageYOffset;

      if (currentScroll > 10) {
        header.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
      } else {
        header.style.boxShadow = '0 2px 4px rgba(0,0,0,0.05)';
      }
    });
  }

  function initCartUpdate() {
    document.addEventListener('cart:updated', function(e) {
      updateCartCount(e.detail.item_count);
    });

    if (typeof Shopify !== 'undefined' && Shopify.onItemAdded) {
      const originalOnItemAdded = Shopify.onItemAdded;
      Shopify.onItemAdded = function(line_item) {
        fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            updateCartCount(cart.item_count);
          });
        
        if (typeof originalOnItemAdded === 'function') {
          originalOnItemAdded(line_item);
        }
      };
    }
  }

  function updateCartCount(count) {
    const cartIcons = document.querySelectorAll('.SPM__navbar__cart');
    
    cartIcons.forEach(function(cartIcon) {
      let countElement = cartIcon.querySelector('.SPM__navbar__cart-count');
      
      if (count > 0) {
        if (!countElement) {
          countElement = document.createElement('span');
          countElement.className = 'SPM__navbar__cart-count';
          cartIcon.appendChild(countElement);
        }
        countElement.textContent = count;
        
        countElement.style.animation = 'none';
        setTimeout(function() {
          countElement.style.animation = 'pulse 0.4s ease';
        }, 10);
      } else {
        if (countElement) {
          countElement.remove();
        }
      }
    });
  }

  function initDropdownEnhancements() {
    const dropdownItems = document.querySelectorAll('.SPM__navbar__menu-item--dropdown');

    dropdownItems.forEach(function(item) {
      const link = item.querySelector('.SPM__navbar__menu-link');
      const dropdown = item.querySelector('.SPM__navbar__dropdown');

      if (!link || !dropdown) return;

      link.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          item.classList.toggle('active');
        }
      });

      if ('ontouchstart' in window) {
        link.addEventListener('click', function(e) {
          if (!item.classList.contains('active')) {
            e.preventDefault();
            
            dropdownItems.forEach(function(otherItem) {
              if (otherItem !== item) {
                otherItem.classList.remove('active');
              }
            });
            
            item.classList.add('active');
          }
        });

        document.addEventListener('click', function(e) {
          if (!item.contains(e.target)) {
            item.classList.remove('active');
          }
        });
      }
    });
  }

  function initSearchEnhancements() {
    const searchInputs = document.querySelectorAll('.SPM__navbar__search-input');

    searchInputs.forEach(function(input) {
      input.addEventListener('input', function() {
        if (this.value.length > 0) {
          this.style.paddingRight = '40px';
        } else {
          this.style.paddingRight = '15px';
        }
      });

      input.addEventListener('keypress', function(e) {
        if (e.key === 'Enter') {
          const form = this.closest('form');
          if (form) {
            form.submit();
          }
        }
      });
    });
  }

  function initAccessibility() {
    const menuItems = document.querySelectorAll('.SPM__navbar__menu-item--dropdown');
    
    menuItems.forEach(function(item, index) {
      const link = item.querySelector('.SPM__navbar__menu-link');
      const dropdown = item.querySelector('.SPM__navbar__dropdown');
      
      if (link && dropdown) {
        const id = 'dropdown-' + index;
        link.setAttribute('aria-expanded', 'false');
        link.setAttribute('aria-controls', id);
        dropdown.setAttribute('id', id);
        
        item.addEventListener('mouseenter', function() {
          link.setAttribute('aria-expanded', 'true');
        });
        
        item.addEventListener('mouseleave', function() {
          link.setAttribute('aria-expanded', 'false');
        });
      }
    });
  }

  if (!document.querySelector('#spm-sr-only-styles')) {
    const style = document.createElement('style');
    style.id = 'spm-sr-only-styles';
    style.textContent = `
      .sr-only {
        position: absolute;
        width: 1px;
        height: 1px;
        padding: 0;
        margin: -1px;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        white-space: nowrap;
        border-width: 0;
      }
      
      @keyframes pulse {
        0%, 100% { transform: scale(1); }
        50% { transform: scale(1.1); }
      }
    `;
    document.head.appendChild(style);
  }

  window.SPMNavbar = {
    updateCartCount: updateCartCount
  };

})();